import { Component, OnInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-price-breakup-banquet',
  templateUrl: './price-breakup-banquet.component.html',
  styleUrls: ['./price-breakup-banquet.component.css']
})
export class PriceBreakupBanquetComponent implements OnInit {

  currOrganization: any;
  loggedInUser: any;
  banquetData: any;
  isAdminHotel: any = false;
  // isCorporate: any = false;

  constructor(
    private activeModal: NgbActiveModal
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
    }
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }
  }

  @Input() data: any;
  @Input() bookingData: any;
  @Input() isCorporate: any;

  ngOnInit(): void {
    this.processBreadCrumbLinks();
  }

  private processBreadCrumbLinks() {
    console.log('data!!! ', this.data, this.bookingData, this.isCorporate);
    this.banquetData = this.bookingData;
    if(this.banquetData && this.banquetData.confirmedCorpId && this.banquetData.confirmedCorpId == 'aTMs0GGvmoONQ7vzzHik') {
      this.isAdminHotel = true;
    }
  }

  getReadableTime(userTime) {
    if (userTime) {
      let hourFormat = userTime.hour <= 9 ? ('0' + userTime.hour) : userTime.hour
      let minFormat = userTime.minute <= 9 ? ('0' + userTime.minute) : userTime.minute
      let format = userTime.hour <= 12 ? 'AM' : 'PM'
      if (format == 'PM') {
        hourFormat = hourFormat - 12
        hourFormat = hourFormat <= 9 ? ('0' + hourFormat) : hourFormat
      }
      return (hourFormat || 0) + ':' + (minFormat || 0) + ' ' + format;
    }
  }

  closeModal() {
    this.activeModal.dismiss();
  }

}
